import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

import { querySelector } from 'selectors'
import { title } from 'styles/texts'

import ConsultantList from 'components/ConsultantList'

const Wrapper = styled.div``

const Text = styled.div`
  ${title};
  width: 910px;
  margin: 0 auto;
`

const Bold = styled.span`
  font-weight: 700;
`

const NoResults = ({ query, suggestion, searchInputChanged, search }) => (
  <Wrapper>
    <ConsultantList availabilityDropdown />
    <Text>
      Ingen resultater for <Bold>{query}</Bold>.
    </Text>
    <Text>Prøv å endre tilgjengelighet, eller søk på noe annet.</Text>
  </Wrapper>
)

const mapStateToProps = state => ({
  query: querySelector(state),
})

export default connect(mapStateToProps)(NoResults)



// WEBPACK FOOTER //
// ./src/components/NoResults.js